export const GET_WEBSITE_LIST = 'GET_WEBSITE_LIST';
export const GET_WEBSITE_LIST2 = 'GET_WEBSITE_LIST2';
export const AUTH_FILTER={
  admin:{
    loginUrl:"/login"
    // successUrl:"/admin",//登陆成功地址
  },
  wap:{
    loginUrl:"/wp/login",
    successUrl:"/wp/index",//登陆成功地址
  }
};

export const SESSION_KEY="CHUANYIN-LOGIN-USER";
export const WAP_SESSION_KEY="CHUANYIN-WAP-USER";










// WEBPACK FOOTER //
// ./src/config/const.js